module.exports = __webpack_public_path__ + "static/media/correcto_val.1bdb55f7.png";